import { BlogPost } from 'lib/types';
import { Pagination } from 'components/Pagination/BasicPagination';
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useApi } from 'lib/contexts/ApplicationState';
import { useRouter } from 'next/router';
import { ServiceMeta } from 'server/api/types';
import { useSnackbar } from 'notistack';
import { LoadingOverlay } from 'components/LoadingOverlay';
import { BlogCard } from './BlogCard';

interface Props {
  blogPosts?: BlogPost[];
  blogMeta?: any;
  noPagination?: boolean;
}

export const BlogPostList = ({ blogPosts, blogMeta, noPagination = false }: Props) => {
  const [posts, setPosts] = useState<BlogPost[]>(blogPosts || []);
  const [meta, setMeta] = useState<ServiceMeta>(blogMeta || undefined);
  const API = useApi();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const {
    isPending, error, isFetching, data,
  } = useQuery({
    queryKey: ['listBlogPosts', router.query],
    queryFn: async () => API.listBlogPosts({ ...router.query, size: 8 }),
    staleTime: Infinity,
  });

  useEffect(() => {
    if (data) {
      setPosts(data.data);
      setMeta(data.meta);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar, error]);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-2">
        {(isPending || isFetching) ? <LoadingOverlay open />
          : posts.map((post) => (
            <div className="col-span-1" key={post.sourceId}>
              <BlogCard
                post={post}
              />
            </div>
          ))}
      </div>
      {(meta && !noPagination) && <Pagination paging={meta.paging} canSeeAllPages />}
    </>
  );
};
